import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { updateCustomPlan } from "../api/updateCustomPlan";

export const useUpdateCustomPlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ companyId, body }) => updateCustomPlan(companyId, body),
    onSuccess: () => {
      toast.success("Custom plan updated successfully!");
      queryClient.invalidateQueries({ queryKey: ["subscriptionDetails"] });
      queryClient.invalidateQueries({ queryKey: ["allSubscriptions"] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to update custom plan.");
    },
  });
};

